import React, { Component } from 'react'
import { withFirebase } from '../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm, Popup } from 'semantic-ui-react'
import { Redirect, Route } from 'react-router-dom'

/*Redux */
import 'firebase/firestore'
import 'firebase/auth'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
/* Components */
import GetAllBlogs from './GetAllBlogs';
import AddBlog from './AddBlog';
import EditBlog from './EditBlog'
/* Actions */
import { getUserData } from '../../Actions/MobilePaymentProfileAction';

/* Routes */
import {SIGN_IN, ADMIN_LAND_PAGE, ALL_BLOGS,
        ADD_BLOG, EDIT_BLOG} from '../../routes';

class BlogAuth extends Component {

  constructor(props) {
      super(props);
      if (firebase.auth().currentUser) {
          firebase.auth().currentUser.getIdToken().then((token) => {
              this.props.getUserData(token);
          })
      }
  }

  componentDidMount() {
      const { userPaymentProfile } = this.props;
      const { auth } = this.props;
      if (!auth.uid) {
          return <Redirect to={SIGN_IN}></Redirect>
      }
  }

  render() {
    const { userPaymentProfile } = this.props;

    if(userPaymentProfile.user_role.role === "Analyst"){
      return <Redirect to={ADMIN_LAND_PAGE}></Redirect>
    }
    return (
      <span>
          {/* Reporting */}
          <Route path={ALL_BLOGS} component={GetAllBlogs} />
          <Route path={ADD_BLOG} component={AddBlog} />
          <Route path={EDIT_BLOG} component={EditBlog} />
      </span>
    )
  }
}

const mapStateToProps = state => ({
    auth: state.firebase.auth,
    userPaymentProfile: state.userPaymentProfile.item,

})

export default withFirebase
(connect
    (mapStateToProps,
        {getUserData}
    )(BlogAuth)
);
